import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild, ElementRef, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Chart, registerables } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import axios from 'src/app/Service/axios';
Chart.register(...registerables);

export interface KPIIndicator {
  AvgPowerFactor: number;
  AvgLoadPercentage: number;
  AvgGeneratorEfficiency: number;
  AvgPhaseHealth: number;
  AvgElectricalHealth: number;
  TotalOnlineGenerators: number;
}

export interface LoadRangeDistribution {
  LoadRange: string;
  DeviceCount: number;
}

export interface HealthScore {
  strName: string;
  iPhaseHealthScore: number;
  iElectricalHealthScore: number;
}

export interface EfficiencyScore {
  strName: string;
  iPowerFactor: number;
  iGeneratorEfficiency: number;
}

export interface ReportIndicatorsResponse {
  Table: KPIIndicator[];
  Table1: LoadRangeDistribution[];
  Table2: HealthScore[];
  Table3: EfficiencyScore[];
}


@Component({
  selector: 'app-load-watch-dashboard-indicators',
  templateUrl: './load-watch-dashboard-indicators.component.html',
  styleUrls: ['./load-watch-dashboard-indicators.component.css']
})
export class LoadWatchDashboardIndicatorsComponent implements OnInit {
  reportIndicators: ReportIndicatorsResponse | null = null;

  private distributionChartInstance: Chart | null | any = null;
  private healthChartInstance: Chart | null = null;
  private pfChartInstance: Chart | null = null;
  private efficiencyChartInstance: Chart | null = null;

  @ViewChild('distributionChart') distributionCanvas!: ElementRef<HTMLCanvasElement>;
  @ViewChild('healthChart') healthCanvas!: ElementRef<HTMLCanvasElement>;
  @ViewChild('pfChart') pfCanvas!: ElementRef<HTMLCanvasElement>;
  @ViewChild('efficiencyChart') efficiencyCanvas!: ElementRef<HTMLCanvasElement>;

  searchForm: FormGroup = this._formBuilder.group({
    strSession: new FormControl(this._gurd.decrypt(localStorage.getItem('Session')!)),
    iSystemUser: new FormControl(this._gurd.decrypt(localStorage.getItem('ID')!)),
  });

  constructor(
    private _tooltip: NotificationService,
    private _formBuilder: FormBuilder,
    private _gurd: GurdServiceService,
    public _other: OtherService,
    private _router: Router,
    private route: ActivatedRoute
  ) {
    Chart.register(...registerables);
    Chart.register(zoomPlugin);
  }

  ngOnInit(): void {
    this.fetchData()
  }

  ngAfterViewInit(): void {
    this.initCharts();
  }

  ngOnDestroy(): void {
    this.destroyCharts();
  }

  fetchData = async (showLoading: boolean = true) => {
    const model = this._other.stringNumberToNumber(this.searchForm.value);

    if (showLoading) {
      this._other.Showspinner()
    }

    let res = JSON.parse((await axios.post(`LoadWatchs_Indicators_Dashboard`, model)).data.toString());
    this._other.nonespinner();

    if (res.ISSessionExpired == true) {
      this._tooltip.showError('لطفا وارد سیستم شوید');
      this._other.removeLocalStorage();
      this._router.navigate(['login'], { queryParams: { error: '3' } });
      return;
    }

    if (res.iResult == 0) {
      return this._tooltip.showError(res.strError);
    }

    this.reportIndicators = res;

    this.updateDashboard();

  }

  formatNumber(num: number | undefined | null, digits: number = 2): string {
    if (num === undefined || num === null || isNaN(num)) return '--';
    return Number(num).toFixed(digits);
  }

  private initCharts(): void {
    // ۱. چارت توزیع بار (Pie)
    this.distributionChartInstance = new Chart(this.distributionCanvas.nativeElement, {
      type: 'pie',
      data: {
        labels: [],
        datasets: [{
          data: [],
          backgroundColor: ['#4fc3f7', '#4caf50', '#ffb74d', '#ef5350', '#ce93d8', '#fff176']
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            labels: {
              color: '#b0bec5',
              font: { family: 'vazir' }
            }
          }
        }
      }
    });

    // ۲. چارت وضعیت سلامت فازها و سیستم الکتریکال (Bar)
    this.healthChartInstance = new Chart(this.healthCanvas.nativeElement, {
      type: 'bar',
      data: {
        labels: [],
        datasets: [
          {
            label: 'سلامت فازها',
            data: [],
            backgroundColor: 'rgba(79, 195, 247, 0.7)',
            borderColor: '#4fc3f7',
            borderWidth: 1
          },
          {
            label: 'سلامت برق',
            data: [],
            backgroundColor: 'rgba(76, 175, 80, 0.7)',
            borderColor: '#4caf50',
            borderWidth: 1
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            labels: {
              color: '#b0bec5',
              font: { family: 'vazir' }
            }
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: { color: '#78909c' },
            grid: { color: '#1e293b' }
          },
          x: {
            ticks: {
              color: '#78909c',
              font: { family: 'vazir', size: 10 }
            },
            grid: { display: false }
          }
        }
      }
    });

    // ۳. چارت ضریب توان (Bar)
    this.pfChartInstance = new Chart(this.pfCanvas.nativeElement, {
      type: 'bar',
      data: {
        labels: [],
        datasets: [{
          label: 'ضریب توان',
          data: [],
          backgroundColor: 'rgba(255, 183, 77, 0.7)',
          borderColor: '#ffb74d',
          borderWidth: 1
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            labels: {
              color: '#b0bec5',
              font: { family: 'vazir' }
            }
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            max: 1.0,
            ticks: { color: '#78909c' },
            grid: { color: '#1e293b' }
          },
          x: {
            ticks: {
              color: '#78909c',
              font: { family: 'vazir', size: 10 }
            },
            grid: { display: false }
          }
        }
      }
    });

    // ۴. چارت راندمان ژنراتورها (Bar)
    this.efficiencyChartInstance = new Chart(this.efficiencyCanvas.nativeElement, {
      type: 'bar',
      data: {
        labels: [],
        datasets: [{
          label: 'راندمان (%)',
          data: [],
          backgroundColor: 'rgba(156, 39, 176, 0.7)',
          borderColor: '#ce93d8',
          borderWidth: 1
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            labels: {
              color: '#b0bec5',
              font: { family: 'vazir' }
            }
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: { color: '#78909c' },
            grid: { color: '#1e293b' }
          },
          x: {
            ticks: {
              color: '#78909c',
              font: { family: 'vazir', size: 10 }
            },
            grid: { display: false }
          }
        }
      }
    });
  }

  private updateDashboard(): void {
    if (!this.reportIndicators) return;

    const table1 = this.reportIndicators.Table1 || [];
    const table2 = this.reportIndicators.Table2 || [];
    const table3 = this.reportIndicators.Table3 || [];

    // بروزرسانی دیتای چارت توزیع بار
    if (this.distributionChartInstance && table1.length > 0) {
      this.distributionChartInstance.data.labels = table1.map(r => r.LoadRange);
      this.distributionChartInstance.data.datasets[0].data = table1.map(r => r.DeviceCount);
      this.distributionChartInstance.update();
    }

    // بروزرسانی دیتای چارت مقایسه سلامت فازها و سیستم برق
    if (this.healthChartInstance && table2.length > 0) {
      this.healthChartInstance.data.labels = table2.map(r => r.strName);
      this.healthChartInstance.data.datasets[0].data = table2.map(r => r.iPhaseHealthScore);
      this.healthChartInstance.data.datasets[1].data = table2.map(r => r.iElectricalHealthScore);
      this.healthChartInstance.update();
    }

    // بروزرسانی دیتای چارت ضریب توان و راندمان
    if (table3.length > 0) {
      if (this.pfChartInstance) {
        this.pfChartInstance.data.labels = table3.map(r => r.strName);
        this.pfChartInstance.data.datasets[0].data = table3.map(r => r.iPowerFactor);
        this.pfChartInstance.update();
      }

      if (this.efficiencyChartInstance) {
        this.efficiencyChartInstance.data.labels = table3.map(r => r.strName);
        this.efficiencyChartInstance.data.datasets[0].data = table3.map(r => r.iGeneratorEfficiency);
        this.efficiencyChartInstance.update();
      }
    }
  }

  private destroyCharts(): void {
    if (this.distributionChartInstance) this.distributionChartInstance.destroy();
    if (this.healthChartInstance) this.healthChartInstance.destroy();
    if (this.pfChartInstance) this.pfChartInstance.destroy();
    if (this.efficiencyChartInstance) this.efficiencyChartInstance.destroy();
  }

}
